import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class LocationDetailReportService extends Service {
    constructor() {
        super();
        this.baseURL = 'locationDetailReport';
    }

    findLocationsByType(type) {
        return fetch(SERVER_URL + this.baseURL + '/findLocationsByType/' + type, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

}